import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const AccountTrancheUpdate = ({ event }: { event: any }) => {
  const getActionText = () => {
    switch (event.data.trancheEvent) {
      case 'addAccount':
        return 'added the account to tranche';
      case 'removeAccount':
        return 'removed the account from tranche';
      case 'reassignAccount':
        return 'reassigned the account to tranche';
      default:
        return 'updated the account tranche';
    }
  };

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> {getActionText()} <strong>{event?.data?.trancheName}</strong> (
        {event?.data?.trancheStatus})
      </Box>
    </Box>
  );
};

export default AccountTrancheUpdate;
